import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabStateService {
  private activeTabSource = new BehaviorSubject<string>('schedule');
  activeTab$ = this.activeTabSource.asObservable();

  setActiveTab(tab: string) {
    this.activeTabSource.next(tab);
  }
} 